export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/pc-500-74ce9452c9007fa2460068ae79923cbb.png";